import React, { useEffect } from "react";

import { Action } from "constants/events";
import { MenuItem } from "custom-types/MenuItem";
import { useEventTracker } from "hooks/useEventTracker";

import Carousel from "components/botanic/Carousel";
import MenuItemCard from "components/botanic/MenuItemCard";
import DispensaryFulfillmentInfo from "components/DispensaryFulfillmentInfo";
import DispensaryPickupFulfillmentInfo from "components/DispensaryPickupFulfillmentInfo";
import { MenuItemCardActions } from "components/Shared/MenuItemCarousel/MenuItemCardActions";

type Props = {
  brandName: string;
  brandId: number;
  products: MenuItem[];
};
const ShopNearbySection: React.FC<Props> = ({
  brandName,
  brandId,
  products,
}) => {
  const { publishEvent } = useEventTracker();

  useEffect(() => {
    publishEvent({
      action: Action.impression,
      brandId,
      category: "brand paid",
      label: "products near you",
    });
  }, []);

  return (
    <Carousel
      title={<h2 className="heading--m">Products near you</h2>}
      subtitle={`Shop these ${brandName} products at stores near you`}
      seeMoreText="see all products"
      seeMoreHref={`/search/shop?shopCategory=brand&shopName=${brandName}`}
    >
      {products.map((menuItem) => (
        <MenuItemCard
          key={menuItem.id}
          menuItem={menuItem}
          handleCardClick={() => {
            publishEvent({
              action: Action.click,
              brandId,
              category: "brand paid",
              label: "products near you card",
              menuItemId: menuItem.id,
            });
          }}
          renderFulfillmentInfo={(dispensary) =>
            dispensary.hasDeliveryEnabled ? (
              <DispensaryFulfillmentInfo dispensary={dispensary} />
            ) : (
              <DispensaryPickupFulfillmentInfo dispensary={dispensary} />
            )
          }
        >
          <MenuItemCardActions menuItem={menuItem} />
        </MenuItemCard>
      ))}
    </Carousel>
  );
};

export default ShopNearbySection;
